<template>
  <section
    v-if="numReservation"
    class="error-wrapper"
  >
    <div
      class="heading"
      v-html="$t('pages.payment_error.title', {reservation: numReservation})"
    />
    <template
      v-if="email && agencyPhone"
    >
      <p
        class="message"
        v-html="$t('pages.payment_error.message5')"
      />
      <p
        class="message"
        v-if="email"
        v-html="$t('pages.payment_error.message1', {email})"
      />
      <p
        class="message"
        v-if="agencyPhone"
        v-html="$t('pages.payment_error.message2', {phone: agencyPhone})"
      />
      <rent-button
        href="/"
        is-anchor
      >
        {{ $t('pages.payment_error.back' ) }}
      </rent-button>
    </template>
    <div
      v-else
      class="loading"
    >
      <small-loading-animation />
    </div>
  </section>
  <section
    v-else-if="demanderReservationError"
    class="error-wrapper"
  >
    <p
      class="message"
      v-html="$t('pages.payment_error.title2')"
    />
    <p
      class="message"
      v-if="fieldError"
      v-html="$t('pages.payment_error.message4', {fieldError})"
    />
    <p
      class="message"
      v-html="$t('pages.payment_error.message6', {email, phone: agencyPhone})"
    />
  </section>
  <section
    v-else
    class="error-wrapper"
  >
    <p
      class="message"
      v-html="$t('pages.payment_error.message3', {phone: agencyPhone})"
    />
  </section>
</template>
<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import RentButton from '../../shared/RentButton'
import SmallLoadingAnimation from '../../shared/SmallLoadingAnimation'

export default {
  components: {
    RentButton,
    SmallLoadingAnimation,
  },
  props: {
    isInQuotation: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    this.AGENCY_PHONE = window.renaultRent?.lead?.business?.phone
  },
  mounted() {
    if (this.isInQuotation) {
      this.clearReservation()
    }
  },
  watch: {
    email(newVal) {
      if (newVal) {
        this.clearReservation()
      }
    },
  },
  computed: {
    ...mapState({
      email: (state) => state?.user?.details?.email,
      storeAgencyPhone: (state) => state.booking?.pickUp?.business?.phone,
      demanderReservationError: (state) => state.leads.demanderReservationError,
      fieldError: (state) => state.leads.fieldError,
    }),
    agencyPhone() {
      return this.AGENCY_PHONE || this.storeAgencyPhone
    },
    numReservation() {
      /* eslint-disable-next-line camelcase */
      return window.renaultRent.lead?.booking_id
    },
  },
  methods: {
    ...mapMutations([
      'stepping/SET_CURRENT_STEP',
    ]),
    ...mapActions({
      clearCompletedInfo: 'leads/CLEAR_COMPLETED_BOOKING_INFO',
    }),
    clearReservation() {
      this.clearCompletedInfo()
      this['stepping/SET_CURRENT_STEP'](1)
    },

  },
}
</script>
<style lang="scss" scoped>

.error-wrapper {
  margin: 3rem auto;
  max-width: 700px;
  width: calc(100vw - 20px);
}

.heading {
  color: black;
  font-family: $f-graphie-book;
  font-size: 2.8rem;
  margin: 0 0 3rem;
  text-align: center;
}

.message {
  color: black;
  font-size: 1.6rem;
}

.loading {
  margin: 10rem auto;
  max-width: 10rem;
}
</style>
